import { FieldType } from '@databases/model/field';
import { type Value, type MutableValue, type ValueJSON } from '@databases/model/value';
import * as Y from 'yjs';

import { SynchronizedRecord } from '../helpers/synchronized-record';
import { ValueProperties } from '../y-entry';
import { FieldMapping } from '../y-field';

export class YCheckboxValue
  extends SynchronizedRecord
  implements Value<FieldType.Checkbox>, MutableValue<FieldType.Checkbox>
{
  constructor(input: Y.Map<any>) {
    super(input);
  }

  get type(): FieldType.Checkbox {
    return FieldType.Checkbox;
  }

  get isEmpty() {
    return !this.value;
  }

  get value(): boolean {
    return this.getBoolean(ValueProperties.value, false);
  }

  set value(data: boolean) {
    this.set(ValueProperties.value, data);
  }

  toJSON(): ValueJSON<FieldType.Checkbox, boolean> {
    return {
      type: this.type,
      value: this.value,
    };
  }

  static fromJSON(json: ValueJSON<FieldType.Checkbox, boolean>) {
    return new YCheckboxValue(
      new Y.Map([
        [ValueProperties.type, FieldMapping[json.type]],
        [ValueProperties.value, json.value],
      ])
    );
  }
}
